import React, { useContext, useEffect, useState } from "react";
import { getData, postData } from "../lib/utils";
import { useNavigate } from "react-router-dom";
import { Context } from "../components/contexts/AppContext";

function Login() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

useEffect(() => {
  const checkAuth = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) return;

    const response = await getData("admin/verifyToken");

    if (response?.success) {
      navigate("/studio/galleries");
    } else {
      localStorage.removeItem("authToken");
    }
  };

  checkAuth();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await postData("admin/login", {
      email: email,
      password: password,
      role:'admin'
    });



    if (response.token) {
      localStorage.setItem("authToken", response.token);
   // localStorage.setItem("token", response.token);
      
      if (response.data.role === "superadmin") {
        navigate("/clientdata");
      } else {
        setAppState((prevState) => {
          return { ...prevState, adminDetails: response.data };
        });
        if (response.data.plan === "n/a") {
          navigate("/checkout");
        } else {
          console.log("studio gallery")
         navigate("/studio/galleries");
      //   navigate("/checkout");//temporary added ashwin
        }
      }
    } else {
      alert(response.message); //Admin not active yet
    }
  };
  return (
   <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">

  {/* LEFT SIDE IMAGE */}
 {/* LEFT SIDE IMAGE */}
<div className="hidden md:block relative h-screen">

  {/* IMAGE */}
  <img
    src="/img/login-half.png"
    alt="Login Banner"
    className="w-full h-full object-cover opacity-200"
  />

  {/* DARK OVERLAY */}
  <div className="absolute inset-0 bg-black/40"></div>

  {/* TEXT CONTENT */}
  <div className="absolute bottom-16 left-12 z-10 text-white">
    
   

    <h1 className="text-5xl font-bold leading-tight mb-4">
      Preserve Every <br /> Wedding Memory
    </h1>

    <p className="text-lg text-gray-200 max-w-md leading-relaxed">
      AI-powered photo galleries for photographers & studios.
      Deliver premium wedding experiences with VidMantra.
    </p>
  </div>
</div>

  {/* RIGHT SIDE LOGIN */}
  <section className="bg-gray-50 dark:bg-gray-900 flex items-center justify-center min-h-screen px-6 py-8">
    
    <div className="w-full max-w-md">
      
      {/* LOGO */}
 

      {/* LOGIN CARD */}
      <div className="w-full text-left bg-white rounded-2xl shadow-2xl border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
        
        <div className="p-8 space-y-6">
          
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Welcome Back
            </h1>

            <p className="text-gray-500 mt-2">
              Sign in to continue
            </p>
          </div>

          <form
            className="space-y-5"
            onSubmit={handleSubmit}
          >
            
            {/* EMAIL */}
            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Your email
              </label>

              <input
                type="email"
                name="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 rounded-xl focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Enter your email"
                required
              />
            </div>

            {/* PASSWORD */}
            <div>
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Password
              </label>

              <input
                type="password"
                name="password"
                id="password"
                placeholder="••••••••"
                onChange={(e) => setPassword(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 rounded-xl focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                required
              />
            </div>

            {/* FORGOT PASSWORD */}
            <div className="flex justify-end">
              <a
                href="/forgot-password"
                className="text-sm text-[#7a0a02] hover:underline"
              >
                Forgot Password?
              </a>
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              className="w-full bg-[#0f172a] hover:bg-[#1e293b] text-white font-semibold py-3 rounded-xl transition"
            >
              Sign In
            </button>

            {/* SIGNUP */}
            <p className="text-sm text-center text-gray-500 dark:text-gray-400">
              Don’t have an account yet?{" "}
              <a
                href="/signup"
                className="font-semibold text-[#7a0a02] hover:underline"
              >
                Sign up
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Login;
